<template>
  <div>
    <TopNav>
      <template v-if="success" v-slot:breadcrumb>
        <v-breadcrumbs :items="breadcrumbItems">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :to="item.to"
              exact
              :replace="true"
              :append="false"
              :disabled="item.disabled"
            >
              {{ item.isDecisionName === true ? decision.name : item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </template>
      <template v-if="success" v-slot:barmenu>
        <v-btn @click="$router.replace('/decisions')" v-ripple="{ class: 'primary--text' }" class="rounded-0" text>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn id="int-tr-trgt-1" @click="setCurrentList(0)" :disabled="loadingOptions" v-ripple="{ class: 'primary--text' }" class="rounded-0" :class="{'active': currentList === 0}" text>
          <v-badge
            color="info"
            :content="researchDocsCount"
            :value="researchDocsCount > 0"
            inline
          >
            <!--v-icon>mdi-view-dashboard-variant</v-icon-->

            <span>{{ $t('navigation.research') }}</span>
          </v-badge>
        </v-btn>
        <v-btn id="int-tr-trgt-2" @click="setCurrentList(1)" :disabled="loadingOptions" v-ripple="{ class: 'primary--text' }" class="rounded-0" :class="{'active': currentList === 1}" text>
          <v-badge
            color="info"
            :content="optionsCount"
            :value="optionsCount > 0"
            inline
          >
            <!--v-icon>mdi-view-dashboard-variant</v-icon-->

            <span>{{ $t('navigation.options') }}</span>
          </v-badge>
        </v-btn>
        <v-btn id="int-tr-trgt-3" @click="setCurrentList(2)" :disabled="loadingOptions || shortListCount === 0" v-ripple="{ class: 'primary--text' }" class="rounded-0" :class="{'active': currentList === 2}" text>
          <v-badge
            :color="shortListCount > 2 ? 'success' : 'info'"
            :content="shortListCount"
            :value="shortListCount > 0"
            inline
          >
            <!--v-icon>mdi-format-list-checks</v-icon-->

          <span>{{ $t('navigation.shortList') }}</span>
          </v-badge>
        </v-btn>

        <v-btn id="int-tr-trgt-4" @click="setCurrentList(3)" :disabled="loadingOptions || shortListCount === 0"  v-ripple="{ class: 'primary--text' }" class="rounded-0" :class="{'active': currentList === 3}" text>
          <v-icon :color="chosenOption !== null ? 'success' : 'info' ">{{ chosenOption !== null ? 'mdi-check-decagram' : 'mdi-check' }}</v-icon>
            <span>Review</span>
        </v-btn>
      </template>
      <template v-if="success" v-slot:drawermenu>
        <v-subheader>{{ decision.name }}</v-subheader>
        <v-list-item @click="setCurrentList(0)" :disabled="loadingOptions" :class="{'active': currentList === 0}">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-edit</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navigation.research') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="setCurrentList(1)" :disabled="loadingOptions" :class="{'active': currentList === 1}">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navigation.options') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setCurrentList(2)" :disabled="loadingOptions || shortListCount === 0" :class="{'active': currentList === 2}">
          <v-list-item-icon>
            <v-icon>mdi-format-list-checks</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navigation.shortList') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setCurrentList(3)" :disabled="loadingOptions || shortListCount === 0" :class="{'active': currentList === 3}">
          <v-list-item-icon>
            <v-icon>{{ chosenOption !== null ? 'mdi-check-decagram' : 'mdi-check' }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Review
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </template>
    </TopNav>
    <v-container v-if="loading" class="pa-6">
      <v-row align="start" justify="center">
        <div>
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-row>
    </v-container>
    <div v-else>
      <div v-if="success">
        <v-expansion-panels v-if="this.currentList !== 3" v-model="expansionPanelsOpen">
          <v-expansion-panel :disabled="currentUserID !== decision.owner">
            <v-expansion-panel-header class="reduced-expansion-header-padding">
              <template v-slot:default="{ open }">
                <v-row no-gutters>
                  <v-col sm="8" md="4" class="d-flex align-center" id="int-tr-trgt-manage"><h3>{{ decision.name }}</h3></v-col>
                  <v-col
                    sm="4" md="8"
                    class="text--secondary"
                  >
                    <v-fade-transition leave-absolute>
                      <span
                        v-if="open"
                        key="0"
                      >
                        Edit decision name and manage sharing
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                        <div class="d-none d-md-flex">
                          <UserAvatar v-for="decisionMember in decision.members" :key="decisionMember.email"
                            class="mr-2"
                            :displayName="decisionMember.displayName"
                            :email="decisionMember.email"
                            :photoUrl="decisionMember.photoUrl"
                            :size="24"
                          />
                        </div>
                        <div v-if="decisionMembersCount > 0" class="d-flex d-md-none">
                          {{ decisionMembersCount }} {{ decisionMembersCount === 1 ? 'other' : 'others' }} deciding
                        </div>
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col>
                  <v-text-field
                    v-model="editingName"
                    placeholder="Name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-dialog
                    v-model="deleteMemberDialog"
                    persistent
                    max-width="500"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Remove decision member
                      </v-card-title>
                      <v-card-text>Remove {{deleteMemberName}} from sharing in this decision?</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="deletingMembers"
                          @click="deleteMemberDialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="error"
                          :disabled="deletingMembers"
                          :loading="deletingMembers"
                          @click="deleteSelectedMember()"
                        >
                          Delete
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-card
                    class="mx-auto"
                  >
                    <v-card-text>
                      Sharing
                    </v-card-text>
                    <div>
                      <v-card-text>
                        <v-chip  v-for="(decisionMember, key) in decision.members" :key="decisionMember.email"
                          outlined
                          class="ma-2"
                          :close="!deletingMembers"
                          color="info"
                          close-icon="mdi-delete"
                          @click:close="removeMember(decisionMember, key)"
                        >
                          <UserAvatar
                            class="mr-2"
                            :displayName="decisionMember.displayName"
                            :email="decisionMember.email"
                            :photoUrl="decisionMember.photoUrl"
                            :size="24"
                            showFullName
                          />
                        </v-chip>
                      </v-card-text>
                      <v-card-subtitle>
                        <DecisionSharingDialog v-if="currentUserID === decision.owner" :decisionName="editingName" label="Add Member" :decisionId="decisionId" @onShared="handleShareWithUser"></DecisionSharingDialog>
                      </v-card-subtitle>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn
                  color="primary"
                  @click="saveDetails"
                >
                  Save
                </v-btn>
                <v-btn
                  text
                  color="info"
                  @click="expansionPanelsOpen = -1"
                >
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-if="currentUserID === decision.owner" v-model="confirmDeleteDialog" persistent max-width="500">
                  <template v-slot:activator="{ on, attrs }">

                    <v-btn
                      text
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Delete this decision
                    </v-btn>

                  </template>

                  <v-card>
                    <v-card-title class="headline grey lighten-2">
                      Delete Decision
                    </v-card-title>

                    <v-card-text class="py-4">
                        Are you sure you want to delete <strong>{{ decision.name }}</strong>?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="info"
                        text
                        :disabled="deleting"
                        @click="confirmDeleteDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="error"
                        :disabled="deleting"
                        :loading="deleting"
                        @click="deleteDecision"
                      >
                        Yes, I am sure
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="currentUserID !== decision.owner">
            <v-expansion-panel-header class="reduced-expansion-header-padding" v-slot="{ open }">
              <v-row no-gutters>
                <v-col sm="9" md="4" class="d-flex align-center" id="int-tr-trgt-criteria">
                  <div
                    v-if="open"
                    key="0"
                  >
                    <h4>
                      Manage your criteria <span v-if="decision.category && !editingCategory"><span class="text-caption">in Category</span> {{decision.category.name}}</span>
                    </h4>
                    <!-- <h4 id="int-tr-trgt-5" class="d-flex align-center mb-2">
                      <v-avatar
                        v-if="!decision.category"
                        :color="decision.category ? 'success' : 'secondary'"
                        size="24"
                        class="mr-1"
                      >
                        <v-icon color="white" small v-if="decision.category">
                          mdi-check
                        </v-icon>
                        <span v-if="!decision.category" class="white--text">1</span>
                      </v-avatar>
                      <span v-if="decision.category && !editingCategory"><span class="text-caption">Deciding in Category</span> {{decision.category.name}}</span>
                      <span v-else>Choose a category</span>
                    </h4>
                    <div v-if="!decision.category">
                      <div class="text-caption">
                        Select a category to see sub categories
                      </div>
                    </div> -->
                  </div>
                  <div
                    v-else
                    key="1"
                    class="d-flex align-center"
                  >
                    <div v-if="!criteriaList || criteriaList.length === 0">What are you interested in?</div>
                    <div v-else>Comparing</div>
                  </div>
                </v-col>
                <v-col
                  sm="3" md="8"
                  class="text--secondary d-flex align-center"
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      &nbsp;
                    </span>
                    <div
                      v-else
                      key="1"
                      class="d-md-flex align-center"
                    >
                      <span v-if="criteriaList.length === 0">Add criteria to help you choose between options</span>
                      <div class="d-none d-md-flex flex-wrap">
                        <v-chip v-for="criteria in criteriaList" :key="criteria.id"
                          :outlined="criteria.ignoreInScrape"
                          color="info"
                          class="mr-2 my-1 py-1 px-3"
                          small
                        >
                          <v-icon small v-if="criteria.keywordOnly" class="mr-1">mdi-list-status</v-icon>
                          {{criteria.name}}
                        </v-chip>
                        <!-- <span class="rounded-pill info mr-2 my-1 py-1 px-3 white--text" v-for="criteria in criteriaList" :key="criteria.id">
                          {{criteria.name}}
                        </span> -->
                      </div>
                      <div v-if="criteriaList.length > 0" class="d-flex d-md-none">
                        {{criteriaList.length}} criteria
                      </div>
                      <div>
                        <NewDecisionCriteriaDialog
                          :decision="decision"
                          :editCriteriaList="criteriaList"
                          @onRename="renameExistingCriteria"
                          @onAdd="addNewCriteria"
                        >
                        </NewDecisionCriteriaDialog>
                      </div>
                      <div class="text-caption pa-0 ml-md-1" v-if="decision.category">
                        In category <strong>{{decision.category.name}}</strong>
                      </div>
                    </div>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col>
                  <div v-if="!decision.category || editingCategory">
                    <DecisionCategorySelect
                      v-model="decision.category"
                      :breadcrumbItems="decision.categoryBreadcrumb"
                      @breadcrumbs="updateCategoryBreadCrumbs"
                      @input="saveCategory"
                    />
                    <div class="mb-6">
                      <div>Can't find an appropriate category?</div>
                      <form class="d-md-flex align-center">
                        <v-combobox
                          id="int-tr-trgt-5b"
                          class="mr-2"
                          v-model="customCategoryName"
                          :items="userCategoryNames"
                          label="Name or select your own category"
                          :error-messages="customCategoryErrors"
                          @change="$v.customCategoryName.$touch()"
                          @keydown="$v.customCategoryName.$touch()"
                          @blur="$v.customCategoryName.$touch()"
                        ></v-combobox>
                        <v-btn
                          color="success"
                          :disabled="!customCategoryName || $v.customCategoryName.$invalid"
                          @click="saveCustomCategory"
                        >
                          Save
                        </v-btn>
                      </form>
                    </div>
                  </div>
                  <v-divider></v-divider>
                  <div v-if="!editCriteriaList || editCriteriaList.length === 0" class="mt-3 d-flex">
                    <h4 class="d-flex align-center mb-2">
                      <v-avatar
                        :color="(editCriteriaList && editCriteriaList.length > 0) ? 'success' : 'secondary'"
                        size="24"
                        class="mr-1"
                      >
                        <v-icon color="white" small v-if="editCriteriaList && editCriteriaList.length > 0">
                          mdi-check
                        </v-icon>
                        <span class="white--text" v-else>2</span>
                      </v-avatar>
                      Manage your criteria
                    </h4>
                  </div>
                  <v-card
                    id="int-tr-trgt-6"
                    class="mx-auto"
                  >
                    <v-card-text v-if="!editCriteriaList || editCriteriaList.length === 0">
                      Add criteria to help you choose between options. Choose from the category suggestions below. Or create your own criteria.
                    </v-card-text>
                    <div v-else>
                      <v-card-subtitle>
                        <v-btn v-if="editCriteriaList.length > 1" @click="setCriteriaEditMode('ordering')/*orderingCriteria = !orderingCriteria*/" class="mr-2 mb-1" x-small outlined :color="orderingCriteria ? 'success' : 'info'">{{ orderingCriteria ? 'Order your Criteria' : 'Order your Criteria' }}</v-btn>

                        <v-btn v-if="editCriteriaList.length > 1" @click="setCriteriaEditMode('keyword')/*orderingCriteria = !orderingCriteria*/" class="mr-2 mb-1" x-small outlined :color="keywordCriteria ? 'success' : 'info'">{{ keywordCriteria ? 'Set Keyword only' : 'Keyword Only' }}</v-btn>

                        <v-btn class="mr-2 mb-1" v-if="editCriteriaList.length > 0" @click="setCriteriaEditMode('excluding')/*excludingCriteria = !excludingCriteria*/" x-small outlined :color="excludingCriteria ? 'success' : 'info'">{{ excludingCriteria ? 'Include/Exclude' : 'Include/Exclude' }}</v-btn>
                        <v-btn class="mr-2 mb-1" v-if="editCriteriaList.length > 0" @click="setCriteriaEditMode('deleting')/*deletingCriteria = !deletingCriteria*/" x-small outlined :color="deletingCriteria ? 'success' : 'info'">{{ deletingCriteria ? 'Remove Criteria' : 'Remove Criteria' }}</v-btn>
                      </v-card-subtitle>
                      <v-card-text>
                        <div>
                          <v-chip v-for="(criteria, index) in editCriteriaList" :key="criteria.id"
                            :outlined="criteria.ignoreInScrape"
                            class="ma-2"
                            :close="keywordCriteria/*!orderingCriteria && !excludingCriteria && !deletingCriteria*/"
                            :color="criteria.newItem ? 'success' : 'info'"
                            :close-icon="criteria.keywordOnly ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"
                            @click:close="toggleCriteriaKeywordOnly(criteria)"
                          >
                            <v-icon small color="success lighten-2" v-if="orderingCriteria" @click="changeCriteriaOrder(index, -1)" :disabled="index === 0" class="mr-2">mdi-arrow-left-circle</v-icon>
                            <v-icon small v-if="keywordCriteria" class="mr-1">{{ criteria.keywordOnly ? 'mdi-list-status' : 'mdi-format-list-bulleted-square' }}</v-icon>
                            {{ criteria.name }}
                            <v-icon small color="error lighten-3" v-if="orderingCriteria" @click="changeCriteriaOrder(index, 1)" :disabled="index === editCriteriaList.length-1" class="ml-2">mdi-arrow-right-circle</v-icon>
                            <v-icon small color="error lighten-4" v-if="deletingCriteria" @click="removeCriteria(criteria)" class="ml-2">mdi-delete</v-icon>
                            <v-icon small v-if="excludingCriteria" @click="toggleIgnoreCriteria(criteria)" class="ml-2">{{ criteria.ignoreInScrape ? 'mdi-magnify-plus' : 'mdi-magnify-minus' }}</v-icon>
                          </v-chip>
                        </div>
                        <div v-if="skipScrapeList && skipScrapeList.length > 0">
                          <div>
                            <span class="text-caption">Not searching for:</span>
                            <v-chip v-for="criteria in skipScrapeList" :key="criteria.id"
                              outlined
                              class="ma-2"
                              color="info"
                              small
                            >
                              {{ criteria.name }}
                            </v-chip>
                          </div>
                          <div class="text-caption">When building options from a website you will need to provide values for these criteria manually</div>
                        </div>
                        <div class="text-caption mt-3" v-if="excludingCriteria">
                          You can click the remove from search button <v-icon small class="mx-2">mdi-magnify-minus</v-icon> to indicate any criteria you do not want to search for when building options from a website. You will then need to provide values for those criteria manually.
                        </div>
                        <div class="text-caption mt-3" v-if="keywordCriteria /*!orderingCriteria && !excludingCriteria && !deletingCriteria*/">
                          You can toggle whether you want to find a value for a criterion <v-icon small class="mx-2">mdi-format-list-bulleted-square</v-icon> or switch to just find out if that keyword exists <v-icon small class="mx-2">mdi-list-status</v-icon>.
                        </div>
                      </v-card-text>
                    </div>
                    <!-- <v-card-actions>
                      <v-btn
                        color="success"
                        @click="saveCriteria"
                        :disabled="!criteriaEditingDirty"
                      >
                        Save changes
                      </v-btn>
                    </v-card-actions> -->
                  </v-card>
                  <!-- <v-container fluid class="my-2 pa-0">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div id="int-tr-trgt-6a">
                          Criteria suggestions <span v-if="decision.category">for <strong>{{decision.category.name}}</strong></span>
                        </div>
                        <CriteriaSelect
                          :category="decision.category"
                          :selectedCriteria="editCriteriaList"
                          @onAdd="addCriteria"
                          @onLoad="updateSuggestedCriteria"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          Or create your own criteria
                          <v-tooltip  bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                              </v-btn>
                            </template>
                            <span>Your criteria can be anything! megapixels, energy rating, friendliness. Decidedly will match them to values or let you fill them in yourself for each option.</span>
                          </v-tooltip>
                        </div>
                        <div>
                          <form class="d-md-flex align-center">
                            <v-text-field
                              id="int-tr-trgt-6b"
                              class="mr-2"
                              v-model="customCriteriaName"
                              :error-messages="customCriteriaErrors"
                              :counter="60"
                              single-line
                              dense
                              placeholder="New criteria name"
                              @input="$v.customCriteriaName.$touch()"
                              @blur="$v.customCriteriaName.$touch()"
                              ></v-text-field>
                            <v-btn
                              color="success"
                              :disabled="!customCriteriaName || $v.customCriteriaName.$invalid"
                              @click="addCustomCriteria"
                            >
                              Add
                            </v-btn>
                          </form>
                        </div>
                        </v-col>
                      </v-row>
                  </v-container> -->
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions class="px-0 mt-2">
                <v-btn
                  id="int-tr-trgt-7"
                  color="primary"
                  :disabled="!criteriaEditingDirty"
                  @click="saveCriteria(); expansionPanelsOpen = -1;"
                >
                  Save
                </v-btn>
                <v-btn
                  id="int-tr-trgt-7"
                  text
                  @click="expansionPanelsOpen = -1"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel :disabled="currentUserID !== decision.owner" v-if="this.currentList > 0 && this.currentList < 3 && this.criteriaList && this.criteriaList.length > 0" class="d-lg-none">
            <v-expansion-panel-header class="reduced-expansion-header-padding">
              <template v-slot:default="{ open }">
                <v-row no-gutters>
                  <v-col sm="8" md="4" class="d-flex align-center">Ranges</v-col>
                  <v-col
                    sm="4" md="8"
                    class="text--secondary"
                  >
                    <v-fade-transition leave-absolute>
                      <span
                        v-if="open"
                        key="0"
                      >
                        &nbsp;
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                        {{ decision.criteriaValueRanges ? `for ${Object.keys(decision.criteriaValueRanges).length} criteria` : 'Set ranges for your criteria' }}
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <CriteriaRangeEditor v-model="decision.criteriaValueRanges" :horizontal="true" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="this.currentList > 0 && this.currentList < 3 && this.criteriaList && this.criteriaList.length > 0" class="d-lg-none">
            <v-expansion-panel-header class="reduced-expansion-header-padding">
              <template v-slot:default="{ open }">
                <v-row no-gutters>
                  <v-col sm="8" md="4" class="d-flex align-center">Sorting by</v-col>
                  <v-col
                    sm="4" md="8"
                    class="text--secondary"
                  >
                    <v-fade-transition leave-absolute>
                      <span
                        v-if="open"
                        key="0"
                      >
                        &nbsp;
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                        {{ computedSortMethod.id === 'criteria' ? `${computedSortCriteria.name}` : `${computedSortMethod.label}` }}
                        <v-tooltip  bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.stop="toggleSortAscending" v-bind="attrs" v-on="on">
                              <v-icon color="primary">{{ sortAscending ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ ascendingTooltip }}</span>
                        </v-tooltip>
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-select
                  v-model="computedSortMethod"
                  :hint="`${computedSortMethod.description}`"
                  :items="sortingMethods"
                  item-text="label"
                  item-value="id"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
                <v-select v-if="sortMethod === 'criteria'"
                  v-model="computedSortCriteria"
                  :items="criteriaList"
                  item-text="name"
                  item-value="id"
                  return-object
                  single-line
                ></v-select>
              </v-row>
              <v-row no-gutters>
                <v-tooltip  bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="toggleSortAscending" v-bind="attrs" v-on="on">
                      <v-icon color="primary">{{ sortAscending ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ ascendingTooltip }}</span>
                </v-tooltip>
              </v-row>
              <v-card-actions>
                <v-btn
                  color="primary"
                  @click="expansionPanelsOpen = -1"
                >
                  Done
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
        <v-container v-if="loadingOptions" class="px-6 pt-6 mt-6">
          <v-row no-gutters justify="space-between" class="mt-6">
            <v-col cols="12" class="d-md-flex">
              <v-skeleton-loader
                width="200"
                class="mx-2 my-2"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                width="200"
                class="mx-2 my-2"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                width="200"
                class="mx-2 my-2"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                width="200"
                class="mx-2 my-2"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
        <div v-else class="px-6">
          <v-container>
            <v-row no-gutters justify="space-between">
              <v-col sm="12" md="10">
                <ResearchList
                  v-if="this.currentList === 0"
                  :researchDocs="sortedResearchDocs"
                  @onNewResearchDoc="handleResearchDocAdded"
                  @onResearchDocDeleted="handleResearchDocDeleted"
                >
                </ResearchList>
                <div v-else-if="this.currentList === 3">
                  <div class="my-4 d-flex justify-center">
                    <h1 class="primary--text">
                      {{decision.name}}
                      <EditDecisionNameDialog v-if="currentUserID === decision.owner" v-model="decision.name" :decisionId="decision.id"></EditDecisionNameDialog>
                    </h1>
                  </div>
                  <div class="my-4 d-flex justify-center">
                    <div>
                      <span v-if="decision.description">{{decision.description}}</span>
                      <span v-else class="text-caption text--secondary">Write a more detailed description to help others understand this decision</span>
                      <EditDecisionDescriptionDialog v-if="currentUserID === decision.owner" v-model="decision.description" :decisionId="decision.id"></EditDecisionDescriptionDialog>
                    </div>
                  </div>
                  <!-- <div class="d-flex" :class="{'flex-column-reverse': currentUserID === decision.owner, 'flex-column': currentUserID !== decision.owner}"> -->
                  <div class="d-flex flex-column">
                    <div class="review-section my-4" v-if="sortedResearchDocs.length > 0">
                      <h2>Things to consider when choosing</h2>
                      <div class="text-caption">Check out these helpful links to learm more about this decision.</div>
                      <div>
                        <ResearchList
                          :researchDocs="sortedResearchDocs"
                          :isMutable="false"
                        >
                        </ResearchList>
                      </div>
                    </div>
                    <!-- <div class="review-section my-4">
                      <h2>Options</h2>
                      Options summary
                    </div> -->
                    <div class="review-section my-4">
                      <h2>The Shortlist</h2>
                      <div>
                        <a href="#" @click.prevent="setCurrentList(1)">See all options</a>
                      </div>
                      <div>
                        <div v-for="shortListItem in shortList" :key="shortListItem.id" class="d-flex flex-column align-center">
                          <DecidedOptionCard :minCardWidth="220" :maxCardWidth="600" :option="shortListItem" :img-url="shortListItem.imgSrc" :isComparable="false" :isEditable="false" :isChosenOption="false">
                          </DecidedOptionCard>
                        </div>
                      </div>
                    </div>
                    <div class="review-section my-4" v-if="decidedOption">
                      <v-divider class="mb-4"></v-divider>
                      <h2>The Final Decision</h2>
                      <div class="text-caption">After cosidering all the pros and cons, the final decision was...</div>
                      <div class="d-flex flex-column align-center mt-6">
                        <DecidedOptionCard :option="decidedOption" :maxCardWidth="600" :img-url="decidedOption.imgSrc" :isComparable="false" :isEditable="false" :isChosenOption="true">
                        </DecidedOptionCard>
                      </div>
                    </div>
                  </div>
                </div>
                <OptionsList
                  v-else
                  :options="sortedOptions"
                  :criteriaRanges="decision.criteriaValueRanges"
                  :isMutable="canAddOptions"
                  @onOptionDeleted="handleOptionDeleted"
                >
                  <template v-slot:sorting>
                    <v-select
                      v-model="computedSortMethod"
                      :hint="`${computedSortMethod.description}`"
                      :items="sortingMethods"
                      item-text="label"
                      item-value="id"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                    <v-select v-if="sortMethod === 'criteria'"
                      v-model="computedSortCriteria"
                      :items="criteriaList"
                      item-text="name"
                      item-value="id"
                      return-object
                      single-line
                    ></v-select>
                    <v-tooltip  bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="toggleSortAscending" v-bind="attrs" v-on="on">
                          <v-icon color="primary">{{ sortAscending ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ ascendingTooltip }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:empty>
                    <!--div class="empty-list-message-container" v-if="!loadingOptions && currentList === 1">
                      <v-btn icon>
                        <v-icon color="primary" @click="newOption">mdi-plus-circle</v-icon>
                      </v-btn>
                      Create options using links or upload files so you can start choosing between things and make your big decision!
                      <div class="text-caption">An option is anything you want to consider for this decision. You can easily import an option using urls and files, or manual build the option details yourself.</div>
                    </div-->
                    <div class="empty-list-message-container" v-if="!loadingOptions && currentList === 2">
                      Heart your top 3 from <a href="#" @click="setCurrentList(1)">all your options</a> to add to your short list
                    </div>
                    <div class="empty-list-message-container" v-if="!loadingOptions && currentList === 3">
                      Star your chosen option from your short list'
                    </div>
                  </template>
                </OptionsList>
              </v-col>
              <v-col v-if="this.currentList > 0 && this.currentList < 3 && this.criteriaList && this.criteriaList.length > 0" cols="2" class="d-none d-lg-flex">
                <CriteriaRangeEditor v-model="decision.criteriaValueRanges" :horizontal="false" :readonly="currentUserID !== decision.owner" />
              </v-col>
            </v-row>
          </v-container>
        </div>
        <!-- Q&A -->
        <v-container v-if="decidedOption">
          <v-card flat>

            <v-card-title class="d-block">Questions and Answers <div class="text-caption">Want to learn more about how this decision was made or any options in it?</div></v-card-title>
            <v-card-text class="d-md-flex">
              <v-textarea
                outlined
                rows="1"
                auto-grow
                name="qa-message"
                label="Ask a question about this decision"
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-container>
        <!-- Suggestions -->
        <v-container fluid class="grey lighten-4" v-if="showExperimentalFeatures">
          <v-container v-if="this.currentList !== 3 && this.criteriaList && this.criteriaList.length > 0">
            <v-card class="grey lighten-4" flat>

              <v-card-title class="d-block">Suggestions <!--div class="text-caption">Coming Soon</div--></v-card-title>
              <v-card-text>
                <v-slide-group
                  v-model="selectedSuggestion"
                  class="pa-4"
                  show-arrows
                >
                  <v-slide-item
                    v-for="option in options" :key="option.id"
                    v-slot="{ active, toggle }"
                  >
                    <v-card
                      :color="active ? 'primary' : 'white lighten-1'"
                      class="ma-4"
                      width="240"
                      @click="toggle"
                    >
                    <v-card-actions>
                      <v-btn
                        color="success"
                        small
                        @click="showCriteriaValues = false"
                      >
                        Add
                      </v-btn>
                    </v-card-actions>
                      <v-img
                        :src="option.imgSrc"
                        height="160px"
                      ></v-img>
                      <v-card-title class="subtitle-2" :class="{'white--text': active}">{{option.name}}</v-card-title>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>

                <v-expand-transition>
                  <v-sheet
                    v-if="selectedSuggestion != null"
                    height="200"
                    tile
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                      <h3 class="title">
                        Suggestion {{ selectedSuggestion }} coming soon...
                      </h3>
                    </v-row>
                  </v-sheet>
                </v-expand-transition>


                  <!-- <v-skeleton-loader
                    width="200"
                    class="mr-2 my-2"
                    type="card"
                  ></v-skeleton-loader>
                  <v-skeleton-loader
                    width="200"
                    class="mr-2 my-2"
                    type="card"
                  ></v-skeleton-loader> -->
              </v-card-text>

            </v-card>
          </v-container>
        </v-container>
      </div>
      <v-container fluid v-else>
        <v-row align="start" justify="center">
          <div>
            No Access
          </div>
        </v-row>
      </v-container>
    </div>
    <v-tour name="decisionTour" :steps="decisionIntrosteps" :callbacks="introTourCallbacks" :options="introOptions"></v-tour>
    <v-tour name="criteriaTour" :steps="criteriaIntrosteps" :callbacks="criteriaIntroTourCallbacks" :options="criteriaIntroOptions"></v-tour>
  </div>
</template>

<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

import { mapState, mapGetters } from 'vuex'

// vuelidate
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, url } from 'vuelidate/lib/validators'

// @ is an alias to /src
import TopNav from '@/components/TopNav.vue'
import OptionsList from '@/components/OptionsList.vue'
import ResearchList from '@/components/ResearchList.vue'
import DecidedOptionCard from '@/components/DecidedOptionCard.vue'
import UserAvatar from '@/components/UserAvatar.vue'
import DecisionCategorySelect from '@/components/DecisionCategorySelect.vue'
// import CriteriaSelect from '@/components/CriteriaSelect.vue'
import CriteriaRangeEditor from '@/components/CriteriaRangeEditor.vue'
import DecisionSharingDialog from '@/components/DecisionSharingDialog.vue'
import EditDecisionNameDialog from '@/components/EditDecisionNameDialog.vue'
import EditDecisionDescriptionDialog from '@/components/EditDecisionDescriptionDialog.vue'
import NewDecisionCriteriaDialog from '@/components/NewDecisionCriteriaDialog.vue'

// Mixins
import guid from '@/mixins/DecidedlyGUID.js'
import checkInRange from '@/mixins/ValueInRange.js'

// Veux types
import * as DecisionTypes from '../store/types/decision'
import * as DecisionsTypes from '../store/types/decisions'

// Custom validations
const notEndingWithColon = (value) => { return !value || value.length === 0 || value.indexOf(':') !== (value.length -1) }

export default {
  name: 'decision',
  components: {
    TopNav,
    OptionsList,
    ResearchList,
    DecidedOptionCard,
    UserAvatar,
    DecisionCategorySelect,
    // CriteriaSelect,
    CriteriaRangeEditor,
    DecisionSharingDialog,
    EditDecisionNameDialog,
    EditDecisionDescriptionDialog,
    NewDecisionCriteriaDialog
  },
  mixins: [validationMixin, guid, checkInRange],
  validations: {
    newOptionModel: {
      name: { required, maxLength: maxLength(100) },
      url: { url }
    },
    decision: {
      name: { required, maxLength: maxLength(60) }
    },
    customCriteriaName: {
      minLength: minLength(3),
      maxLength: maxLength(60),
      isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (!value || value === '') return true

        let existingIndex = -1
        if (this.editCriteriaList) {
          //indexExists = this.editCriteriaList.map(function(c) { return c.name }).indexOf(value)
          existingIndex = this.editCriteriaList.findIndex(item => item.name.toLowerCase() === value.toLowerCase())
        }
        return existingIndex < 0
      },
      notEndingWithColon
    },
    customCategoryName: {
      minLength: minLength(3),
      maxLength: maxLength(60)
    }
  },
  data () {
    return {
      decision: null,
      editingName: '',
      editingCategory: false,
      loading: true,
      success: false,
      editCriteriaList: [],
      criteriaEditingDirty: false,
      customCriteriaName: null,
      // chosenOption: null,
      longList: [],
      decidedList: [],
      theOne: null,
      breadcrumbItems: [],
      currentExpansionPanel: -1,
      confirmDeleteDialog: false,
      deleting: false,
      deletingMembers: false,
      deleteMemberDialog: false,
      deleteMember: null,
      orderingCriteria: false,
      keywordCriteria: false,
      excludingCriteria: false,
      deletingCriteria: false,
      customCategoryName: null,
      userCategories: [],
      selectedSuggestion: null,
      sortingMethods: [
        {id: 'createdAt', label: 'Date Created', description: 'Order by date created', sortFunction: this.sortOptionsByCreatedAt},
        {id: 'name', label: 'Name', description: 'Order by option name', sortFunction: this.sortOptionsByName},
        {id: 'criteria', label: 'Criteria', description: 'Order by selected criteria', sortFunction: this.sortOptionsByCriteria}
      ],
      introOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Got it!'
        }
      },
      criteriaIntroOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Continue'
        }
      },
      decisionIntrosteps: [
        {
          target: '.logo-container',  // We're using document.querySelector() under the hood
          content: `<h3>Welcome to your Decision Board</h3> Decision Boards help you keep track of everything you need to make the right decision.`
        },
        {
          target: '#int-tr-trgt-1',
          content: 'The <strong>Research</strong> tab is where you can store links to any supporting websites that help you understand more about the decision you are making.'
        },
        {
          target: '#int-tr-trgt-2',
          content: '<p>The <strong>Options</strong> tab is where you can bookmark all the options you are deciding between.</p> <p>Decidedly will help you organize and compare them.</p>'
        },
        {
          target: '#int-tr-trgt-3',
          content: 'The <strong>Shortlist</strong> tab is where you can focus on your favourite options.'
        },
        {
          target: '#int-tr-trgt-4',
          content: '<p>And finally, the <strong>Review</strong> becomes a place for you to review your choice and help others.</p>'
        },
        // {
        //   target: '#int-tr-trgt-manage',
        //   content: 'To manage your Decision you can expand this section and rename, share or delete it.',
        //   offset: -100
        // },
        {
          target: '#int-tr-trgt-criteria',
          content: '<p>Expanding this section lets you manage your Decision Criteria.</p> <p>Decidedly will find values for these so you can compare them.</p>',
          offset: -100
        },
        {
          target: '#int-tr-trgt-8',
          content: '<p>With your Criteria ready.</p><p>Click the add button to bookmark any webpages you\'re considering.</p> Decidedly will help find and fill in the rest!',
          offset: -100
        }
      ],
      criteriaIntrosteps: [
        // {
        //   target: '#int-tr-trgt-5',
        //   content: 'Organize your decision criteria by Category to get the most out of Decidedly',
        //   offset: -100,
        //   params: {
        //     placement: 'top'
        //   }
        // },
        // {
        //   target: '#int-tr-trgt-5a',
        //   content: 'You can choose an existing category.',
        //   offset: -150
        // },
        // {
        //   target: '#int-tr-trgt-5b',
        //   content: '<p>Or create your own. Just give it a name!</p><p>It will be saved so you can re-use it for other decisions.</p>',
        //   offset: -200,
        // },
        {
          target: '#int-tr-trgt-6',
          content: '<p>Manage your criteria.</p><p>Here you can change the default order of criteria, remove them and change how you find values for them.</p>',
          offset: 200,
          params: {
            placement: 'bottom'
          }
        },
        // {
        //   target: '#int-tr-trgt-6a',
        //   content: '<p>Select from suggested criteria based on your Category.</p><p>We\'ll go ahead and make sure Price is one of your criteria now.</p>',
        //   offset: -200,
        //   params: {
        //     placement: 'top'
        //   }
        // },
        // {
        //   target: '#int-tr-trgt-6b',
        //   content: '<p>Simply add your own criteria keywords here when something is missing from the suggestions.</p>',
        //   offset: -200,
        // },
        {
          target: '#int-tr-trgt-7',
          content: 'Any options you add will find values for the features you have chosen here.',
          offset: -100
        }
      ],
      introTourCallbacks: {
        onPreviousStep: this.tourPreviousStepCallback,
        onNextStep: this.tourNextStepCallback,
        onSkip: this.tourSkippedCallback
      },
      criteriaIntroTourCallbacks: {
        onNextStep: this.criteriaTourNextStepCallback,
        onSkip: this.tourSkippedCallback,
        onFinish: this.criteriaTourFinishedCallback
      },
      introTourStepCounter: 0
    }
  },
  mounted: function () {
    this.loading = true
    // this.decisionId = this.$route.params.decisionId
    this.$store.commit(`decision/${DecisionTypes.MUTATION_DECISION_ID}`, this.$route.params.decisionId)
    this.fetchDecision()
    if (!this.hideIntro && this.prefsLoaded) { // If prefs are not loaded then tour will be triggered by a watch of the hideIntro state
      this.$tours['decisionTour'].start()
    }
  },
  computed: {

    ...mapState({
      decisionId: state => state.decision.decisionId,
      chosenOption: state => state.decision.chosenOption,
      loadingOptions: state => state.decision.fetchingStatus,
      currentList: state => state.decision.currentList,
      decisionTaxon: state => state.decision.currentTaxon,
      sortAscending: state => state.decision.sortAscending,
      sortMethod: state => state.decision.sortMethod,
      sortCriteria: state => state.decision.sortCriteria,
      hideIntroPreference: state => state.user.hideIntro,
      prefsLoaded: state => state.user.loaded,
      showExperimentalFeatures: state => state.user.showExperimentalFeatures
    }),
    ...mapGetters('decision', {
      criteriaList: 'criteriaList',
      researchDocs: 'researchDocs',
      options: 'optionsForCurrentList',
      shortList: 'shortListOptions',
      shortListCount: 'shortListCount',
      optionsCount: 'totalOptionsCount',
      researchDocsCount: 'researchDocsCount'
    }),
    hideIntro () {
      return this.$vuetify.breakpoint.mobile || this.hideIntroPreference
    },
    currentUserID () {
      return firebase.auth().currentUser.uid
    },
    expansionPanelsOpen: {
      // getter
      get: function () {
        return this.currentExpansionPanel
      },
      // setter
      set: function (newValue) {
        // console.log(`openPane val = ${newValue}`)
        if ((newValue === -1 || !newValue /*Could be set as null or undefined*/) && this.currentExpansionPanel !== -1) {
          // Closing expansion panels so revert changes
          if (this.editingName !== this.decision.name) {
            this.editingName = this.decision.name
          }
          // Handle tour logic if the tour is enabled
          if (!this.hideIntro) {
            // When we are at the point in the tour when we need to decide whether to proceed based on whether th user has any criteria
            // console.log(`Panel closing tourStepCount = ${this.introTourStepCounter}`)
            this.$tours['criteriaTour'].stop()
            this.setCurrentList(1)
            if (this.introTourStepCounter >= 5) {
              // Stop everything if there are no criteria
              if (this.criteriaList && this.criteriaList.length === 0) {
                this.$tours['decisionTour'].stop()
                // this.$tours['criteriaTour'].stop()
              } else {
                // Otherwise continue with the decision tour which will suggest creating options
                // this.$tours['criteriaTour'].stop()

                this.$tours['decisionTour'].start(7)
                this.introTourStepCounter = 7
              }
            } else {
              this.$tours['decisionTour'].start(this.introTourStepCounter)
            }
          }
        } else if (newValue === 1) {
          this.orderingCriteria = true
          this.keywordCriteria = false
          this.excludingCriteria = false
          this.deletingCriteria = false
          this.editCriteriaList = [] // We want copies of criteria while editing so we can discard/revert
          this.criteriaList.forEach(item => {
            this.editCriteriaList.push({...item})
          })

          this.customCriteriaName = null
          this.customCategoryName = null
          this.criteriaEditingDirty = false
          this.loadUserCategories()
          // Handle tour logic when opening the criteria pane, we want to start the criteira sub tour
          if (!this.hideIntro) {
            this.$tours['decisionTour'].stop()
            this.$tours['criteriaTour'].start()
          }
        } else if (newValue === 0) {
          // console.log(`Control panel is closing`)
          // this.$tours['decisionTour'].stop()
          this.$tours['criteriaTour'].stop()
        }
        // this.expansionPanelsOpen = newValue
         this.currentExpansionPanel = newValue
      }
    },
    computedSortMethod: {
      // getter
      get: function () {
        return this.sortMethod ? this.sortingMethods.find(method => method.id === this.sortMethod) : this.sortingMethods[0]
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch('decision/changeSortMethod', newValue.id)
      }
    },
    computedSortCriteria: {
      // getter
      get: function () {
        return this.sortCriteria ? this.criteriaList.find(item => item.id === this.sortCriteria) : this.criteriaList[0]
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch('decision/changeSortCriteria', newValue.id)
      }
    },
    sortedOptions () {
      const sortedOptions = [...this.options]

      // Sort current sort method
      if (this.computedSortMethod) {
        sortedOptions.sort(this.computedSortMethod.sortFunction)
      }
      if(!this.sortAscending) {
        sortedOptions.reverse()
      }
      return sortedOptions
    },
    ascendingTooltip () {
      if (this.sortAscending) {
        return 'Sorting in ascending order. Click to change to descending.'
      } else {
        return 'Sorting in descending order. Click to change to ascending.'
      }
    },
    // decisionTaxon () {
    //   let res = null
    //   if (this.decision.category) {
    //     res = this.decision.category.id
    //   }
    //   return res
    // },
    sortedResearchDocs () {
      const sortedDocs = [...this.researchDocs]

      // Sort current sort method
      // if (this.computedSortMethod) {
      //   sortedOptions.sort(this.computedSortMethod.sortFunction)
      // }
      // if(!this.sortAscending) {
      //   sortedOptions.reverse()
      // }
      return sortedDocs
    },
    decidedOption () {
      return this.options.find(option => option.id === this.chosenOption)
    },
    userCategoryNames () {
      return this.userCategories.map(cat => cat.name)
    },
    customCriteriaErrors () {
      const errors = []
      if (!this.$v.customCriteriaName.$dirty) return errors
      !this.$v.customCriteriaName.minLength && errors.push('Criteria name must be at least 3 characters long')
      !this.$v.customCriteriaName.maxLength && errors.push('Criteria name must be at most 60 characters long')
      !this.$v.customCriteriaName.isUnique && errors.push('That name is already in your criteria list')
      !this.$v.customCriteriaName.notEndingWithColon && errors.push('Criteria names cannot end with a colon')
      return errors
    },
    customCategoryErrors () {
      const errors = []
      if (!this.$v.customCategoryName.$dirty) return errors
      !this.$v.customCategoryName.minLength && errors.push('Category name must be at least 3 characters long')
      !this.$v.customCategoryName.maxLength && errors.push('Category name must be at most 60 characters long')
      return errors
    },
    canAddOptions () {
      const readyToAdd = this.currentList === 1 && this.criteriaList && this.criteriaList.length > 0
      const permittedToAdd = this.currentUserID === this.decision.owner || (this.decision.members[this.currentUserID].canAddOptions)

      return readyToAdd && permittedToAdd
    },
    decisionMembersCount () {
      let res = 0
      if (this.decision.members && Object.keys(this.decision.members).length > 0) {
        res = Object.keys(this.decision.members).length
      }
      return res
    },
    deleteMemberName () {
      let res = ''
      if (this.deleteMember && this.deleteMember.data) {
        res = this.deleteMember.data.email
      }
      return res
    },
    skipScrapeList () {
      const res = this.editCriteriaList.filter(criteriaItem => criteriaItem.ignoreInScrape === true)
      res.sort((a, b) => a.order - b.order)
      return res
    }
  },
  watch: {
    hideIntro: function (shouldHide) {
      // console.log(`Hide intro changed ${shouldHide} mutations = ${mutation}`)
        if (shouldHide === true) {
          this.stopDecisionTour()
          this.$tours['criteriaTour'].stop()
        }
        else if (shouldHide === false) {
          this.$tours['decisionTour'].start()
          this.introTourStepCounter = 0
        }
    },
    // This is required as vue-tour will not allow be to cal tour.stop from with their next callback
    introTourStepCounter: function (newValue) {
      if (newValue === 5 && this.expansionPanelsOpen === 1) {
        // Continue with the criteria tour
        this.$tours['decisionTour'].stop()
        this.$tours['criteriaTour'].start()
      }
      if (newValue === 6 && this.criteriaList && this.criteriaList.length === 0) {
        // console.log(`At last step without any criteria`)
        this.$tours['decisionTour'].stop()
      }
    }
  },
  methods: {
    stopDecisionTour: function () {
      this.$tours['decisionTour'].stop()
    },
    // handleToggleShowIntro: function (shouldShowIntro) {
    //   if (shouldShowIntro) {
    //     this.$tours['decisionTour'].start()
    //   } else {
    //     this.$tours['decisionTour'].stop()
    //   }
    // },
    tourPreviousStepCallback: function (currentStep) {
      this.introTourStepCounter = currentStep
      if (currentStep === 2) {
        this.setCurrentList(0)
      } else if (currentStep === 3) {
        this.setCurrentList(1)
      }
      // else if (currentStep === 7 && this.expansionPanelsOpen !== 1) {
      //   this.expansionPanelsOpen = 1
      // }
    },
    tourNextStepCallback: function (currentStep) {
      this.introTourStepCounter = currentStep
      if (currentStep === 0) {
        this.setCurrentList(0)
      } else if (currentStep === 1) {
        this.setCurrentList(1)
      } else if (currentStep === 5 && this.criteriaList.length === 0 && this.expansionPanelsOpen !== 1) {
        this.expansionPanelsOpen = 1
      }
      // else if (currentStep === 4) {
      //   if (this.expansionPanelsOpen !== -1) {
      //     this.expansionPanelsOpen = -1
      //   }
      // }
      // else if (currentStep === 5 && this.criteriaList && this.criteriaList.length === 0) {
      //   console.log(`At last step without any criteria`)
      //   this.$tours['decisionTour'].stop()
      // }
      // else if (currentStep === 3 && this.expansionPanelsOpen !== 1) {
      //   this.expansionPanelsOpen = 1
      // } else if (currentStep === 10) {
      //   this.expansionPanelsOpen = -1
      // }
    },
    criteriaTourFinishedCallback: function () {
      this.expansionPanelsOpen = -1
      this.setCurrentList(1)
      if (this.criteriaList && this.criteriaList.length > 0) {
        this.$tours['decisionTour'].start(6)
      }
    },
    tourSkippedCallback: function () {
      this.$store.dispatch('user/updateHideIntro', true)
    },
    criteriaTourNextStepCallback: function (currentStep) {
      if (currentStep === 1) {
        // Make sure Price is one of the criteria for this intro tutorial
        if (!this.editCriteriaList.find(nextItem => nextItem.id === 'price')) {
          // console.log('Should add Price for tutorial')
          this.addCriteria({"id":"price","name":"Price","taxon":"all"})
          this.saveCriteria()
        }
      }
    },
    changeCriteriaOrder: function (itemIndex, delta) {
      const newIndex = itemIndex + delta
      if (newIndex < 0 || newIndex == this.editCriteriaList.length) return // Item already at the limits
      let indices = [itemIndex, newIndex].sort((a, b) => a - b) // Sort the old and new indices
      this.editCriteriaList.splice(indices[0], 2, this.editCriteriaList[indices[1]], this.editCriteriaList[indices[0]]) // Replace from lowest index, two elements, reverting the order
      // Update order property for storing the order
      this.editCriteriaList.forEach((item, i) => {
        item.order = i+1
      })

      this.criteriaEditingDirty = true
    },
    deleteDecision: async function () {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const deleteURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}`
      // console.log(`Calling delete decision post`)
      this.deleting = true
      const res = await axios.delete(deleteURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });

      if (res && res.status === 200 && res.data && res.data.status === 'success') {
        // console.log('@@@ deleted the decision')
        this.confirmDeleteDialog = false
        this.deleting = false
        this.expansionPanelsOpen = -1
        this.$store.commit(`decisions/${DecisionsTypes.MUTATION_REMOVE_DECISION}`, this.decisionId)
        this.$router.replace('/decisions')
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
      }
    },
    saveDetails: async function () {
      // TODO validated changes to the model name
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}`

      let decisionPayload = {name: this.editingName}
      // console.log(`Calling decision post`)
      const res = await axios.post(postURL, decisionPayload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });

      if (res && res.status === 200 && res.data && res.data.status === 'success') {
        // console.log('@@@ updated the decision')
        this.decision.name = this.editingName

        // Update the modified property in the main decision list
        this.$store.commit(`decisions/${DecisionsTypes.MUTATION_UPDATE_DECISION}`, {
          id: this.decisionId,
          updates: {
            name: this.decision.name
          }
        })

        this.expansionPanelsOpen = -1
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
      }
    },
    saveCustomCategory: async function () {
      if (!this.customCategoryName) {
        return
      }

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postCategoryURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/category`

      // const latestBreadcrumbTrail = []
      this.decision.categoryBreadcrumb = []
      // this.decision.categoryBreadcrumb.forEach(item => {
      //   latestBreadcrumbTrail.push({id: item.id, name: item.name})
      // })

      const categoryData = {
        category: {
          id: '',
          name: this.customCategoryName,
          userDefined: true
        }
      }

      // console.log(`categoryData =  ${JSON.stringify(categoryData)}`)

      const res = await axios.post(postCategoryURL, categoryData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200 && res.data && res.data.status === "success") {
        // Close the criteria drawer and update the local list
        const newCustomCategory = {
          id: res.data.categoryId,
          name: this.customCategoryName,
          userDefined: true
        }
        // console.log(`Setting category to ${JSON.stringify(newCustomCategory)}`)
        this.decision.category = newCustomCategory
        this.customCategoryName = null
      }
    },
    updateSuggestedCriteria: function (suggestedCriteria) {
      this.suggestedCriteria = suggestedCriteria
    },
    renameExistingCriteria: function (change) {
      this.editCriteriaList = [] // We want copies of criteria while editing so we can discard/revert
      this.criteriaList.forEach(item => {
        const editingItem = {...item}
        if (editingItem.id === change.id) {
          // console.log(`Found item to rename from ${item.name} to ${change.name}`)
          editingItem.name = change.name
        }
        // console.log(`Will push ${JSON.stringify(editingItem)}`)
        this.editCriteriaList.push(editingItem)
      })
      this.saveCriteria()
    },
    addNewCriteria: function (criteriaItem) {
      this.editCriteriaList = [] // We want copies of criteria while editing so we can discard/revert
      this.criteriaList.forEach(item => {
        this.editCriteriaList.push({...item})
      })

      criteriaItem.newItem = true
      this.editCriteriaList.push(criteriaItem)
      this.saveCriteria()
    },
    addCriteria: function (criteriaItem) {
      // console.log(`Add Criteria got called ${JSON.stringify(criteriaItem)}`)
      criteriaItem.newItem = true
      this.editCriteriaList.push(criteriaItem)
      this.criteriaEditingDirty = true
      // TODO check if the criteria item matches any existing userGenerated criteria and allow for replacing it.
    },
    addCustomCriteria: async function () {
      const currentTaxonLevel = this.decision.category ? this.decision.category.id : 'unassigned'
      const customCriteriaItem = {name: this.customCriteriaName, id: this.genGUID(), taxon: currentTaxonLevel, userGenerated: true}

      // Check the user is not typing something which is already in the existing list
      const indexInList = this.editCriteriaList.findIndex(item => item.name.toLowerCase() === customCriteriaItem.name.toLowerCase())
      if (indexInList > -1) {
        // console.log('Criteria already in the list')
        this.customCriteriaName = null
        return
      }

      // Check if the name does not match existing suggested criteria
      let matchingSuggestion = null
      if (this.suggestedCriteria) {
        matchingSuggestion = this.suggestedCriteria.find(item => item.name.toLowerCase() === customCriteriaItem.name.toLowerCase())
      }

      if (matchingSuggestion) {
        this.addCriteria(matchingSuggestion)
        this.customCriteriaName = null
        return
      }

      // Check if this custom criteria is a synonym for an existing system criteria in the same taxon
      const existingCriteria = await this.getCriteriaIdForUserValue(customCriteriaItem)
      // Set the id and taxon for the custom criteria to the existing criteria with the value as its synonym
      if (existingCriteria) {
        customCriteriaItem.id = existingCriteria.criteriaId
        customCriteriaItem.taxon = existingCriteria.taxon
        customCriteriaItem.userGenerated = false
      }

      // Check the user is not adding criteria which is already in the list with a different name
      const criteriaInList = this.editCriteriaList.find(item => item.id === customCriteriaItem.id)
      if (criteriaInList) {
        // Rename the item in the list
        criteriaInList.name = customCriteriaItem.name
      } else {
        // Add the custom criteria item
        this.addCriteria(customCriteriaItem)
      }

      this.customCriteriaName = null
    },
    getCriteriaIdForUserValue: async function (customCriteria) {
      if (!customCriteria.name) {
        return null
      }

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      // /categories/:category/criteria/match
      const getURL = `${Constants.API_BASE_PATH}/categories/${customCriteria.taxon}/criteria/match?keyword=${customCriteria.name.toLowerCase()}`
      // console.log(`Calling check criteria get ${getURL}`)
      const res = await axios.get(getURL, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

      if (res && res.status === 200 && res.data && res.data.status === 'success') {
        return res.data
      } else {
        return null
      }
    },
    removeCriteria: function (criteriaItem) {
      const indexOfItem = this.editCriteriaList.map(function(c) { return c.id }).indexOf(criteriaItem.id)
      this.editCriteriaList.splice(indexOfItem, 1)
      this.criteriaEditingDirty = true
    },
    toggleIgnoreCriteria: function (criteriaItem) {
      // this.$set(this.decision.criteria[criteriaItem.id], 'ignoreInScrape', !criteriaItem.ignoreInScrape)
      const indexOfItem = this.editCriteriaList.map(function(c) { return c.id }).indexOf(criteriaItem.id)
      this.$set(this.editCriteriaList[indexOfItem], 'ignoreInScrape', !criteriaItem.ignoreInScrape)
      // this.editCriteriaList[indexOfItem].ignoreInScrape = !criteriaItem.ignoreInScrape
      this.criteriaEditingDirty = true
    },
    toggleCriteriaKeywordOnly: function (criteriaItem) {
      const indexOfItem = this.editCriteriaList.map(function(c) { return c.id }).indexOf(criteriaItem.id)
      this.$set(this.editCriteriaList[indexOfItem], 'keywordOnly', !criteriaItem.keywordOnly)
      this.criteriaEditingDirty = true
    },
    setCriteriaEditMode: function (mode) {
      this.excludingCriteria = mode === 'excluding' ? true : false
      this.deletingCriteria = mode === 'deleting' ? true : false
      this.orderingCriteria = mode === 'ordering' ? true : false
      this.keywordCriteria = mode === 'keyword' ? true : false
    },
    saveCriteria: async function () {
      this.$store.dispatch('decision/updateCriteria', this.editCriteriaList)
      this.criteriaEditingDirty = false
      // if (closePanel) {
      //   this.expansionPanelsOpen = -1
      // }
    },
    saveCategory: async function () {
      // console.log('Calling save category')
      // if (!this.decision.category || !this.decision.categoryBreadcrumb) {
      //   return
      // }

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postCategoryURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/category`

      const latestBreadcrumbTrail = []
      if (this.decision.categoryBreadcrumb) {
        this.decision.categoryBreadcrumb.forEach(item => {
          latestBreadcrumbTrail.push({id: item.id, name: item.name})
        })
      }

      const currentCategory = this.decision.category ? {
        id: this.decision.category.id,
        name: this.decision.category.name
      } : null

      const categoryData = {
        category: currentCategory,
        categoryBreadcrumb: latestBreadcrumbTrail
      }

      // console.log(`Calling post decision cateogry ${JSON.stringify(categoryData)}`)
      await axios.post(postCategoryURL, categoryData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      // if (res && res.status !== 200) {
      //   console.log(`Unexpected response ${JSON.stringify(res)}`)
      // }

    },
    loadUserCategories: async function () {
      this.userCategories = []
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const fetchURL = `${Constants.API_BASE_PATH}/uesrcategories`
      const res = await axios.get(fetchURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res.data && res.data.status === 'success') {
        this.userCategories = res.data.categories
      }
    },
    setCurrentList: function (listNumber) {
      if (this.currentList !== listNumber && listNumber >= 0 && listNumber < 4) {
        // this.currentList = listNumber
        this.$store.commit(`decision/${DecisionTypes.MUTATION_CURRENT_LIST}`, listNumber)

        // if (this.currentList == 2) {
        //   this.currentListTitle = 'Short List'
        // } else if (this.currentList == 2) {
        //   this.currentListTitle = 'Decided'
        // } else {
        //   this.currentListTitle = 'All Options'
        // }
        // // this.loadCurrentList()
        if (this.currentUserID === this.decision.owner) {
          this.saveCurrentList()
        }
      }
    },
    saveCurrentList: async function () {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postDecisionPhaseURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/phase`
      const body = {
        currentList: this.currentList
      }
      // console.log(`Calling decision post current list ${JSON.stringify(body)}`)
      const res = await axios.post(postDecisionPhaseURL, body, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200 && res.data && res.data.status === 'success' ) {
        this.decision.currentList = this.currentList
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
        alert('Unexpected response choosing decision option')
      }
    },
    fetchDecision: async function () {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const decisionURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}`
      const res = await axios.get(decisionURL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      if (res.status >= 200 && res.status < 300) {
        this.decision = res.data

        this.editingName = this.decision.name

        if (!this.decision.categoryBreadcrumb) {
          this.decision.categoryBreadcrumb = []
        }

        // Set decision owner
        this.$store.commit(`decision/${DecisionTypes.MUTATION_DECISION_OWNER}`, this.decision.owner)

        // Set final choice
        const chosenOptionId = this.decision.chosenOption && typeof(this.decision.chosenOption) !== 'undefined' ? this.decision.chosenOption :  null
        this.$store.commit(`decision/${DecisionTypes.MUTATION_CHOSEN_OPTION}`, chosenOptionId)
        // if (this.decision.chosenOption && typeof(this.decision.chosenOption) !== 'undefined') {
        //   this.$store.commit(`decision/${DecisionTypes.MUTATION_CHOSEN_OPTION}`, this.decision.chosenOption)
        //   // this.chosenOption = this.decision.chosenOption
        // }

        // Set the current list
        // TODO force it to be 3 (decided) if there is a chosenOption for this decision
        if (typeof(this.decision.currentList) !== 'undefined') {
          this.$store.commit(`decision/${DecisionTypes.MUTATION_CURRENT_LIST}`, this.decision.currentList)
        } else {
          this.$store.commit(`decision/${DecisionTypes.MUTATION_CURRENT_LIST}`, 1)
        }

        // this.loadCurrentList()
        const currentTaxon = this.decision.category ? this.decision.category.id : null
        this.$store.commit(`decision/${DecisionTypes.MUTATION_CURRENT_TAXON}`, currentTaxon)
        this.$store.commit(`decision/${DecisionTypes.MUTATION_CRITERIA}`, this.decision.criteria)

        if (typeof(this.decision.sortAscending) !== 'undefined') {
          this.$store.commit(`decision/${DecisionTypes.MUTATION_SORT_ASCENDING}`, this.decision.sortAscending)
        }

        this.$store.commit(`decision/${DecisionTypes.MUTATION_SORT_METHOD}`, this.decision.sortMethod)

        this.$store.commit(`decision/${DecisionTypes.MUTATION_SORT_CRITERIA}`, this.decision.sortCriteria)

        this.$store.dispatch('decision/loadAllOptions')

        this.$store.dispatch('decision/loadResearchList')

        this.breadcrumbItems = [
          {
            text: 'Decisions',
            disabled: false,
            to: '/decisions',
          },
          {
            text: this.decision.name,
            disabled: false,
            to: '',
            isDecisionName: true
          }
        ]

        // Open default expansion panels based on decision state
        if (!this.decision.criteria && this.hideIntro) {
          // this.currentExpansionPanel = 1
          this.expansionPanelsOpen = 1
        }

        this.success = true
      } else {
        this.decision = null
        this.success = false
      }

      this.loading = false
    },
    sortOptionsByName: function (a, b) {
      const nameA = a.name.toUpperCase()  // ignore upper and lowercase
      const nameB = b.name.toUpperCase() // ignore upper and lowercase
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }

      // names must be equal
      return 0
    },
    sortOptionsByCreatedAt: function (a, b) {
      const aSeconds = a.createdAt ? a.createdAt._seconds : 0
      const bSeconds = b.createdAt ? b.createdAt._seconds : 0
      return bSeconds - aSeconds
    },
    sortOptionsByCriteria: function (a, b) {
      // const criteriaDataType =
      const aValueObj = a.criteriaValues ? a.criteriaValues[this.computedSortCriteria.id] : null
      const bValueObj = b.criteriaValues ? b.criteriaValues[this.computedSortCriteria.id] : null

      let aVal = ''
      if (aValueObj) {
        aVal = aValueObj.sourceValue || aValueObj.userValue
      }
      let bVal = ''
      if (bValueObj) {
        bVal = bValueObj.sourceValue || bValueObj.userValue
      }

      const aAsNumber = this.valueAsLargestNumber(aVal) || 0
      const bAsNumber = this.valueAsLargestNumber(bVal) || 0

      return aAsNumber - bAsNumber
    },
    toggleSortAscending: function () {
      this.$store.dispatch('decision/toggleSortAscending')
    },
    handleOptionDeleted: function (deletedOption) {
      this.$store.dispatch('decision/removeOption', deletedOption.id)
    },
    // handleOptionAdded: async function (newOption) {
    //   // Fetch the data for the option and add to the list
    //   const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
    //   const getOptionURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${newOption.id}`
    //   // console.log(`Calling decision get optoin`)
    //   const res = await axios.get(getOptionURL, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${token}`,
    //     }
    //   })
    //
    //   if (res && res.status === 200 && res.data && res.data.status === 'success' ) {
    //     const newOptionData = res.data.optionData
    //     newOptionData.decisionId = this.decisionId
    //     newOptionData.newlyAdded = true
    //     this.$store.dispatch('decision/addOption', newOptionData)
    //   } else {
    //     // console.log(`Unexpected response ${JSON.stringify(res)}`)
    //     alert('Unexpected response choosing decision option')
    //   }
    // },
    handleResearchDocDeleted: function (deletedDoc) {
      this.$store.dispatch('decision/removeResearchDoc', deletedDoc.id)
    },
    handleResearchDocAdded: async function (newDoc) {
      const newData = {...newDoc}
      newData.decisionId = this.decisionId
      newData.newlyAdded = true
      this.$store.dispatch('decision/addResearchDoc', newData)
    },
    updateCategoryBreadCrumbs: function (newList) {
      this.decision.categoryBreadcrumb = newList
    },
    handleShareWithUser: function (newMemberData) {
      // console.log (`Notified about new member ${JSON.stringify(newMemberData)}`)
      if (this.decision.members && newMemberData.uid) {
        this.$set(this.decision.members, newMemberData.uid, newMemberData)
      }
    },
    removeMember: async function (memberData, memberUid) {
      this.deleteMember = {uid: memberUid}
      this.deleteMember.data = memberData
      this.deleteMemberDialog = true
    },
    deleteSelectedMember: async function () {
      const memberUid = this.deleteMember.uid
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      ///decisions/:decision/members/:member
      const deleteMemberURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/members/${memberUid}`
      this.deletingMembers = true

      // console.log(`Calling option post criteria ${JSON.stringify(criteriaMap)}`)
      const res = await axios.delete(deleteMemberURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200 && res.data && res.data.status === "success") {
        // Close the criteria drawer and update the local list
        //delete this.decision.members[memberUid]
        this.$delete(this.decision.members, memberUid)
        this.deletingMembers = false
        this.deleteMemberDialog = false
      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
        this.deletingMembers = false
        this.deleteMemberDialog = false
        alert('Unexpected response updating criteria')
      }
    }
  }
}
</script>

<!--
Example fetch using Bearer
async function fetchFromAPI() {

  const user = auth.currentUser;
  const token = user && (await user.getIdToken());

  const res = await fetch(url, {
    methodL 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}
-->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.empty-list-message-container {
  min-height: 100px;
}
.add-decision-button {
  top: 80px;
}
.comparison-list {
  display: flex;
  justify-content: space-around;
}
.new-criteria-action-col {
  width: 30px;
}
.source-value-chip {
      .v-chip__content {
        display: inline-block;
        height: auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px;
      }
}
.reduced-expansion-header-padding {
  padding: 6px 24px;
}
.review-section {
  text-align: center;
}
</style>
